// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gaokao-basic[data-v-721b3654] {\n  flex: 1;\n  box-sizing: border-box;\n  margin-top: 14px;\n  width: 0;\n}\n.basic-card[data-v-721b3654] {\n  line-height: 1.5;\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 10px;\n  overflow: auto;\n}\n.num[data-v-721b3654] {\n  color: #f56c6c;\n  font-weight: bold;\n}\n.basic-card[data-v-721b3654]  .el-icon-question {\n  font-size: 14px;\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
